import type { FacilityRecord } from '../../types/registry';

interface AreaListDialogProps {
  facility: FacilityRecord;
  onClose: () => void;
}

export function AreaListDialog({ facility, onClose }: AreaListDialogProps): JSX.Element {
  const areas = facility.area_ids ?? [];

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card modal-card--wide" onClick={(event) => event.stopPropagation()}>
        <h2>Areas — {facility.name}</h2>
        <p className="modal-card__copy">
          {areas.length ? `${areas.length} area${areas.length === 1 ? '' : 's'} in this facility.` : 'No areas yet.'}
        </p>

        {areas.length ? (
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Floor</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {areas.map((area) => (
                <tr key={area.area_id}>
                  <td>{area.name}</td>
                  <td>{area.floor ?? '—'}</td>
                  <td>{area.description?.trim() || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="empty-state">No areas in this facility.</div>
        )}

        <div className="modal-card__actions">
          <button className="ghost-button" type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
